<template>
  <span
    v-tooltip="tooltip"
    class="tw-inline-block tw-truncate"
    data-testid="ellipsis-container"
    :style="style"
  >
    <span ref="containerRef" class="sf-ellipsis__text"><slot></slot></span>
  </span>
</template>

<script lang="ts" setup>
import { isBreakpoint } from '@app/shared/predicates'

import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { computed, ref } from 'vue'

import { ResponsiveBreakpointsType } from '@app/shared/constants'

type ResponsiveLength = {
  [key in ResponsiveBreakpointsType]?: number
}

interface Props {
  length?: number
  responsiveLength?: ResponsiveLength
  tooltip?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  length: 300,
  responsiveLength: undefined,
  tooltip: '',
})

const containerRef = ref<HTMLElement | null>(null)

const breakpoints = useBreakpoints(breakpointsTailwind)

const effectiveLength = computed(() => {
  if (!props.responsiveLength) {
    return props.length
  }

  const breakpoint = breakpoints.active()

  if (!breakpoint.value || !isBreakpoint(breakpoint.value)) {
    return props.length
  }

  return props.responsiveLength[breakpoint.value] ?? props.length
})

const style = computed(() => {
  return {
    maxWidth: `${effectiveLength.value}px`,
  }
})

const tooltip = computed(() => {
  return (containerRef?.value?.offsetWidth ?? 0) > props.length
    ? props.tooltip
    : ''
})
</script>

<style scoped lang="scss">
.sf-ellipsis__text {
  line-height: inherit;
  font-size: inherit;
}
</style>
